import React from 'react';

import { Heading, Text } from '~/vinovest-design-system/components';

interface WineDescriptionProps {
    description: string;
}

/** Wine description from the lwin11. */
export const WineDescription = ({ description }: WineDescriptionProps) => {
    return (
        <div className={'mb-10'}>
            <Heading level={'h2'} classnames={'py-6'}>
                Why We&apos;re Buying
            </Heading>
            <Text as={'p'} classnames={'leading-loose'}>
                {description}
            </Text>
        </div>
    );
};
